import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../lib/cn';

const lines = [
  { type: 'cmd', content: '> diagnóstico da sua empresa' },
  { type: 'blank', content: '' },
  { type: 'ok', content: '✓ caminho do cliente mapeado' },
  { type: 'ok', content: '✓ pontos de vazamento identificados' },
  { type: 'ok', content: '✓ método pronto pra rodar' },
  { type: 'blank', content: '' },
  { type: 'step', label: '01 · atrair', value: 'R$ vazando' },
  { type: 'step', label: '02 · qualificar', value: 'R$ vazando' },
  { type: 'step', label: '03 · vender', value: 'R$ vazando' },
  { type: 'step', label: '04 · receber bem', value: 'R$ vazando' },
  { type: 'step', label: '05 · entregar', value: 'R$ vazando' },
  { type: 'step', label: '06 · fazer voltar', value: 'R$ vazando' },
  { type: 'blank', content: '' },
  { type: 'run', content: '... somando o seu dinheiro na mesa' },
];

export function HeroTerminal() {
  const [visible, setVisible] = useState(0);

  useEffect(() => {
    if (visible >= lines.length) return;
    const t = setTimeout(() => setVisible((v) => v + 1), visible === 0 ? 500 : 180);
    return () => clearTimeout(t);
  }, [visible]);

  return (
    <div
      className={cn(
        'relative overflow-hidden',
        'rounded-2xl border border-white/10',
        'bg-bg-elevated/80 backdrop-blur-xl',
        'shadow-glow'
      )}
    >
      {/* Title bar */}
      <div className="flex items-center justify-between px-4 py-3 border-b border-white/5 bg-black/40">
        <div className="flex items-center gap-1.5">
          <span className="h-2.5 w-2.5 rounded-full bg-white/15" aria-hidden />
          <span className="h-2.5 w-2.5 rounded-full bg-white/15" aria-hidden />
          <span className="h-2.5 w-2.5 rounded-full bg-white/15" aria-hidden />
        </div>
        <span className="text-[10px] font-mono uppercase tracking-widest text-ink-500">
          diagnóstico · ao vivo
        </span>
        <span className="w-12" />
      </div>

      {/* Body */}
      <div className="p-5 md:p-6 font-mono text-[13px] leading-[1.7] min-h-[360px]">
        {lines.slice(0, visible).map((line, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, x: -8 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.3, ease: [0.4, 0, 0, 1] }}
          >
            {line.type === 'cmd' && (
              <span className="text-ink-300">{line.content}</span>
            )}
            {line.type === 'ok' && (
              <span className="text-brand-300">{line.content}</span>
            )}
            {line.type === 'run' && (
              <span className="text-lavender">{line.content}</span>
            )}
            {line.type === 'step' && (
              <div className="flex items-baseline gap-2 text-ink-400">
                <span className="text-brand-300 shrink-0">&gt;</span>
                <span className="shrink-0">{line.label}</span>
                <span
                  aria-hidden
                  className="flex-1 border-b border-dotted border-white/10 mb-1"
                />
                <span className="text-white shrink-0">{line.value}</span>
              </div>
            )}
            {line.type === 'blank' && <span>&nbsp;</span>}
          </motion.div>
        ))}
        {visible >= lines.length && (
          <div className="text-ink-300">
            $ <span className="inline-block w-2 h-3.5 bg-brand-300 align-middle animate-cursor" />
          </div>
        )}
      </div>
    </div>
  );
}
